<template>
	<el-dialog
		title="用户列表"
		:append-to-body="true"
		:modal-append-to-body="true"
		:close-on-click-modal="falseValue"
		:visible.sync="showDialog"
		:modal="falseValue"
		custom-class="dialog-style list-dialog dialog-checkbox pd_0"
		width="1200px"
		@close="dialogClose"
		v-el-drag-dialog
		v-el-dialog-center
	>
		<div class="cont" style="height:450px">
			<vxe-grid
				class="is-pointer"
				ref="table-m1"
				v-bind="vxeOption"
				@resizable-change="$vxeTableUtil.onColumnWitchChange"
				@custom="$vxeTableUtil.customHandle"
				@checkbox-change="addDataTable"
				@checkbox-all="checkAll"
				@cell-dblclick="checkWithSubmit"
			>
				<template #form>
					<div class="clearfix screen-btns">
						<div class="fr">
							<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>
							<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
						</div>
					</div>
					<vxe-form class="screen-box" title-width="92px" title-align="right" :data="formData" @submit="searchEvent" @reset="resetEvent">
						<vxe-form-item title="登录名:" field="loginAccount">
							<template v-slot>
								<el-input v-model="formData.loginAccount" size="small" clearable />
							</template>
						</vxe-form-item>
						<vxe-form-item title="手机号:" field="mobile">
							<template v-slot>
								<el-input v-model="formData.mobile" size="small" clearable />
							</template>
						</vxe-form-item>
					</vxe-form>
				</template>
			</vxe-grid>
		</div>
		<label id="labBtn" class="transverse">
			<div class="icon">
				<i class="el-icon-more"></i>
				<i class="el-icon-more"></i>
			</div>
		</label>
		<div class="multipleChoice">
			<el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top"><a class="allDel icon-quanbushanchu" @click="clearChecked()"></a></el-tooltip>
			<div class="list">
				<div class="item" v-for="(checkRow, index) in checkRows">
					<p>{{ checkRow.nickName }}</p>
					<a class="el-icon-close" @click="clearTable1Select(index)"></a>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogPrimary" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
export default {
	name: 'userDialog',
	props: ['visiable', 'multi', 'rows', 'param'],
	mixins: [selectDialogMixins],
	created() {
		this.initSetting();
		if (this.param) {
			if (this.param.userType !== null) {
				this.userType = this.param.userType;
			}
		}
	},
	mounted() {
		this.initTableM1();
	},
	data() {
		var that = this;
		return {
			showDialog: true,
			falseValue: false,
			userType: 0,
			formData: {
				saleOrgId: '',
				saleOrgName: ''
			},
			selectMulti: true,
			vxeOption: {}
		};
	},
	methods: {
		initTableM1() {
			var that = this;
			let tableOption = {
				vue: that,
				tableRef: 'table-m1',
				tableName: 'basic_user_dialog-m1',
				path: USER_PREFIX + '/user/listCurrentPage',
				param: () => {
					this.formData.userType = this.userType;
					this.formData.enabled = true;
					return this.formData;
				},
				config: {
					checkboxConfig: {
						checkStrictly: true,
						showHeader: this.selectMulti,
						trigger: 'row'
					}
				},
				columns: [
					{ type: 'checkbox', width: 50, resizable: false, fixed: 'left'},
					{ title: '登录名', field: 'loginAccount', width: 250, fixed: 'left' },
					{ field: 'nickName', title: '姓名', width: 150 },
					{ field: 'mobile', title: '手机号', width: 150 },
					{
						field: 'enabled',
						title: '是否启用',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.enabled) {
									return [<div class="txt-status">启用</div>];
								} else {
									return [<div class="txt-status s-3">禁用</div>];
								}
							}
						}
					},
					{
						field: 'birth',
						title: '出生日期',
						width: 150,
						slots: {
							default: ({ row }) => {
								var val = row.birth;
								if (val) {
									return val.substring(0, 10);
								}
							}
						}
					},
					{ field: 'zipCode', title: '邮编', width: 150 },
					{ field: 'address', title: '地址', width: 150 },
					{
						field: 'gender',
						title: '性别',
						width: 150,
						slots: {
							default: ({ row }) => {
								var val = row.gender;
								if (val == 1) {
									return '男';
								} else if (val == 2) {
									return '女';
								}
							}
						}
					},
					{ field: 'createBy', title: '创建人', width: 150 },
					{ field: 'modifyBy', title: '更新人', width: 150 },
					{ field: 'modifyDate', title: '更新时间', width: 150 },
					{ field: 'createDate', title: '创建时间', width: 150 },
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false
					}
				]
			};
			this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
				that.vxeOption = opts;
			});
		}
	}
};
</script>
